import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monleys NAS Synology',
    title: 'I. Audit et prise en main',
    description: 'L\'objectif est de comprendre vos priorités, d’identifier d’éventuelles failles ou pistes d’amélioration, et de nous familiariser avec votre environnement.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Analyse de la configuration actuelle." },
      { text: 'Détection des failles potentielles.' },
      { text: 'Élaboration d’un plan d’amélioration.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'II. Configuration et intégration',
    description: 'Nous veillons à ce que tout soit configuré pour une administration fluide et fiable et procédons aux ajustements pour optimiser votre environnement existant.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Paramétrage des accès et outils.' },
      { text: 'Optimisation des ressources en place.' },
      { text: 'Alignement avec vos processus internes.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'III. Sécurisation & gestion des identités',
    description: 'De la définition des rôles à la surveillance en continu, nous nous assurons que seules les personnes autorisées accèdent à vos ressources et que toutes vos données sont protégées.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Mise en place d’authentification sécurisée." },
      { text: 'Principe du moindre privilège.' },
      { text: 'Surveillance en continu des accès.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'IV. Administration quotidienne',
    description: 'Avec une supervision 24/7, application des mises à jour, correctifs de sécurité, gestion des performances et allocation des ressources.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Monitoring 24/7 et alertes proactives.' },
      { text: 'Gestion des mises à jour et correctifs.' },
      { text: 'Standardisation des procédures.' },

    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'V. Support continu',
    description: 'Vous disposez d\'un support technique dédié. Nos administrateurs système certifiés assurent la gestion et le suivi de votre infrastructure cloud.',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Support technique réactif.' },
      { text: 'Ajustements réguliers.' },
      { text: 'Gestion proactive des incidents.' },
    ],
  },
];
